import { OfferV1OfferTypeEnum } from '@redteclab/api/clients/bully'

export const offerAccessorIsOfferMirakl = (
  offerType: OfferV1OfferTypeEnum | undefined,
): boolean => offerType === OfferV1OfferTypeEnum.Mirakl
